// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__leHwH","footer":"styles_footer__24eVo"};